<template>
  <div v-wechat-title="titleTop" class="bodyBack">
    <topImg />
    <div class="SerchRect">
      <van-field v-model="search.country" class="SearchLine" placeholder="选择国家" right-icon="arrow-down" readonly @click="showCountryPick=true" />
      <van-field v-model="search.date" class="SearchLine" placeholder="出行日期" right-icon="arrow-down" readonly @click="showDatePick=true" />
      <div class="checkLine">
        <van-row>
          <van-col span="12" class="leftCheckBox"><van-checkbox v-model="search.onlyHave" label-position="left" shape="square" icon-size="16px">仅看有余位船期</van-checkbox></van-col>
          <van-col span="12" class="rightCheckBox">
            <van-checkbox v-model="search.onlySpecial" label-position="left" shape="square" icon-size="16px">仅看特价船期</van-checkbox>
          </van-col>
        </van-row>

      </div>
      <van-button class="searchButton" color="linear-gradient(to right, #0EBEFA , #1A8CFE)" size="large" @click="onSearchJump">搜索船期<i class="iconfont iconlightning" /></van-button>
    </div>

    <div class="OneImgRect" v-if="imgCenterAd" @click="jumpUrl(imgCenterAd.url)">
      <van-image
        fit="cover"
        :width="'calc(100vw - 3em)'"
        height="40vw"
        :src="imgCenterAd.img"
      />
      <div v-if="imgCenterAd.title
      " class="imgTitle"><span>{{imgCenterAd.title}}</span></div>
    </div>

    <div class="twoLineRect">
      <div class="rectTitle"><span>全球顶级潜点</span></div>
      <div class="twoLineFlexRect">

        <div v-for="(item,index) in imgRecommend" :key="index" class="pointRect" @click="jumpUrl(item.url)">
          <van-image
            fit="cover"
            :width="'calc(50vw - 2em)'"
            height="20vw"
            :src="item.img"
            class="pointRect"
          />
          <div class="imgTag"> <i class="iconfont iconlightning" /></div>

          <div class="imgTitle"><span>{{ item.title }}</span></div>
        </div>

      </div>
    </div>
    <!-- <div class="icpLine">蜀ICP备20019214号-1 成都酷潜文化旅游有限公司</div> -->
    <van-popup v-model="showDatePick" position="bottom" class="popDialog">
      <van-picker
        title="选择出行日期"
        show-toolbar
        :columns="dateOption"
        @confirm="onConfirmDate"
        @cancel="onCancelDate"
      />
    </van-popup>
    <van-popup v-model="showCountryPick" position="bottom" class="popDialog">
      <van-picker
        title="选择出行国家"
        show-toolbar
        :columns="countryOption"
        @confirm="onConfirmCountry"
        @cancel="onCancelCountry"
      />
    </van-popup>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <boatKf/>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Picker, Popup, Image, Checkbox  } from 'vant'
// import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import topImg from '@/views/boat/boatTopImgBack.vue'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
import  boatKf from '@/views/boat/boatKf.vue'
export default {
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    topImg,
    wxShare,
    boatKf
  },
  data() {
    return {
      titleTop: '酷潜船宿精选',
      index: 0,
      //oneImg: '/img/boat/home.webp',
      search: {
        country: '',
        countryValue:'',
        date: '',
        dateValue:'',
        onlyHave: false,
        onlySpecial: false
      },
      // images: [{ title: '加拉帕戈斯', img: '/img/boat/point0.webp' },
      //   { title: '马尔代夫', img: '/img/boat/point1.webp' },
      //   { title: '印尼环线', img: '/img/boat/point2.webp' }
      // ],
      dateOption:[],
      countryOption:[],
      showDatePick:false,
      showCountryPick:false,
      imgRecommend:[],
      imgCenterAd:undefined,
      
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''

    }
  },

  created() {
    this.titleTop = '酷潜船宿精选'
    this.initDateList();
    this.initCountryList();
    this.initHomeRes();
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onShareFinish() {
      this.shareUrl = undefined
    },
    onSearchJump(){
      let url = '/boat/boatCountryList?country='+this.search.countryValue+
      "&date="+this.search.dateValue+
      "&onlyHave="+(this.search.onlyHave?"true":"false")+
      "&onlySpecial="+(this.search.onlySpecial?"true":"false")
      this.$router.push(url)
    },
    jumpUrl(url){
      console.log("jumpUrl",url)
      if(url){
        this.$router.push(url)
      }
    },
    initDateList(){
      request({
        url: '/DiveBoat/getDateList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          return
        }
        let list = []
        response.data.forEach(el=>{
          list.push({
            text:el.v,
            value:el.k
          })
        })
       
        this.dateOption= list;
      })
    },
    initCountryList(){
      request({
        url: '/DiveBoat/getCountryList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          return
        }
        let list = []
        response.data.forEach(el=>{
          list.push({
            text:el.v,
            value:el.k
          })
        })
       
        this.countryOption = list;
      })
    },
    onConfirmDate(value){
      
      this.search.date =value.text
      this.search.dateValue = value.value
      this.showDatePick= false;
    },
    onCancelDate(){
      this.search.date = ''
      this.search.dateValue = ''
      this.showDatePick =false;
    },
    onConfirmCountry(value){
      this.search.country =value.text
      this.search.countryValue = value.value
      this.showCountryPick= false;
    },
    onCancelCountry(){
      this.search.country = ''
      this.search.countryValue = ''
      this.showCountryPick = false;
    },
    initHomeRes(){
      request({
        url: '/DiveBoat/getBoatHomeAdList?onlyTop=false',
        method: 'post',
      }).then(response => {
        if (!response.success) {
          return
        }
        this.imgRecommend = response.data.recommend
        this.imgCenterAd = response.data.centerAd
        
        this.shareTitle = '酷潜船宿精选'
        this.shareAbout = '全球精选船宿推荐'
        this.shareTimeline = '全球精选船宿推荐'
        this.shareUrl = undefined
        this.shareUrl = GetSelfUrl() + 'boat?system=cooldive'
        this.shareIcon =response.data.centerAd.img
      })


    }
  }
}
</script>

<style>
.bodyBack{
    background-color:#fff;
    min-height:100vh;
    width:100vw;
    overflow-x:hidden;
}
.SerchRect{
    padding:0 1.5em;
}
.SerchRect .SearchLine{
    border:1px solid #ccc;
    border-radius:5px;
    margin-bottom:1.5em;
}
.searchButton{
    margin-top:1.5em;
    border-radius:0.6em;
    position:relative;
}
.searchButton i{
    position:absolute;
    right:0.6em;
    top:-12px;
    font-size:0.8em;
}
.SerchRect .van-cell{
    padding:5px 16px;
}
.rightCheckBox .van-checkbox{
    float:right;
}
.rightCheckBox .van-checkbox__label{
    font-size:0.8em;
    color:#777 !important;
}
.leftCheckBox .van-checkbox__label{
    font-size:0.8em;
    color:#777 !important;
}

.OneImgRect{
    margin-left:1.5em;
    margin-top:1.5em;
    width:calc(100vw - 3em);
    position:relative;
}
.OneImgRect img{
    border-radius:0.6em;
    overflow:hidden;
}
.OneImgRect .imgTitle{
    position:absolute;
    line-height:3em;
    bottom:0;
    left:0;
    right:0;
    z-index:1;
    text-align:center;
}
.OneImgRect .imgTitle span{
    color:#fff;
    font-size:1.0em;
    letter-spacing: 2px;
    font-weight:700;
}

.twoLineRect{
    margin-top:1.5em;
    padding:0 1.5em;
}
.twoLineRect .rectTitle{
    text-align:center;
    margin-bottom:1.5em;
}
.twoLineRect .rectTitle span{
    font-size:1em;
    font-weight:700;
    color:#3c3c3c;
}
.twoLineRect  .twoLineFlexRect{
    display:flex;
    justify-content: space-between; /* 左右对齐 */
    flex-wrap:wrap;
    padding-bottom:20px;
}
.twoLineRect  .twoLineFlexRect .pointRect{

    width:calc(50vw - 2em);
    height:20vw;
    margin-bottom:1em;
    overflow:hidden;
    position:relative;
    border-radius:0.4em;
    overflow:hidden;
}
.twoLineRect  .twoLineFlexRect  .imgTag{
    position:absolute;
    right:0em;
    top:0;
    background-color:#198BFE;
    border-radius: 0 0.4em 0 0.4em;
    padding:0.1em 0.2em;
}
.twoLineRect  .twoLineFlexRect .pointRect i{
   font-size:0.5em;
   color:#fff;
}
.twoLineRect  .twoLineFlexRect .pointRect .imgTitle{
    position:absolute;
    left:0.4em;
    bottom:0.4em;
    color:#fff;
    font-size:0.7em;
}

.popDialog{
  width:100vw;
}
</style>

